import React, { useState, useEffect } from 'react';

// 1. Import your images
import slide1 from '../components/img/img1.webp'; 
import slide2 from '../components/img/p6.webp'; 
// (Using placeholders or other imports if you have different images) 
const slide3 = slide1;

const Section2 = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const slides = [
        { img: slide1, title: "Connecting the Global Indian to Their Heritage.", desc: "The NRI Welfare Association provides world-class legal, property, and personal advocacy, bridging the distance between you and India." },
        { img: slide2, title: "Your Interests in India, Secured & Shielded.", desc: "From complex property disputes to taxation compliance, our expert team ensures your peace of mind while you reside abroad." },
 
    ];

    // Auto-play logic
    useEffect(() => {
        const timer = setInterval(() => {
            nextSlide();
        }, 5000);
        return () => clearInterval(timer);
    }, [currentIndex]);

    const nextSlide = () => {
        setCurrentIndex((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    };

    const prevSlide = () => {
        setCurrentIndex((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
    };

    return (
        <div className="slider-container">
            {/* Custom CSS */}
            <style>{`
                .slider-container {
                    position: relative;
                    width: 100%;
                    height: 80vh;
                    overflow: hidden;
                    background: #000;
                }
                .custom-slide {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    opacity: 0;
                    transition: opacity 1s ease-in-out, transform 1.2s ease-in-out;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-size: cover;
                    background-position: center;
                    transform: scale(1.1);
                }
                .custom-slide.active {
                    opacity: 1;
                    transform: scale(1);
                }
                .overlay {
                    position: absolute;
                    top: 0; left: 0; width: 100%; height: 100%;
                    background: rgba(0, 0, 0, 0.4);
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    color: white;
                    text-align: center;
                    padding: 20px;
                }
                .overlay h1 {
                    font-size: clamp(2rem, 8vw, 3.5rem);
                    font-weight: bold;
                    margin-bottom: 1rem;
                    text-shadow: 2px 2px 15px rgba(0,0,0,0.7);
                }
                .overlay p {
                    font-size: clamp(1rem, 4vw, 1.25rem);
                    max-width: 600px;
                }
                .nav-btn {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    background: rgba(255,255,255,0.2);
                    border: none;
                    color: white;
                    padding: 15px;
                    cursor: pointer;
                    z-index: 10;
                    border-radius: 50%;
                    transition: background 0.3s;
                }
                .nav-btn:hover { background: rgba(255,255,255,0.4); }
                .prev { left: 20px; }
                .next { right: 20px; }
                
                .dots {
                    position: absolute;
                    bottom: 20px;
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    gap: 10px;
                    z-index: 10;
                }
                .dot {
                    width: 12px;
                    height: 12px;
                    background: rgba(255,255,255,0.5);
                    border-radius: 50%;
                    cursor: pointer;
                }
                .dot.active { background: #fff; width: 30px; border-radius: 10px; }

                @media (max-width: 768px) {
                    .slider-container { height: 60vh; }
                    .nav-btn { display: none; } /* Hide arrows on small mobile */
                }
            `}</style>

            {/* Slides */}
            {slides.map((slide, index) => (
                <div
                    key={index}
                    className={`custom-slide ${index === currentIndex ? 'active' : ''}`}
                    style={{ backgroundImage: `url(${slide.img})` }}
                >
                    <div className="overlay">
                        <h1>{slide.title}</h1>
                        <p>{slide.desc}</p>
                        {/* <button className="btn btn-primary rounded-pill px-4 py-2 mt-3">
                            Get Started
                        </button> */}
                    </div>
                </div>
            ))}

            {/* Navigation Arrows */}
            <button className="nav-btn prev" onClick={prevSlide}>❮</button>
            <button className="nav-btn next" onClick={nextSlide}>❯</button>

            {/* Pagination Dots */}
            <div className="dots">
                {slides.map((_, index) => (
                    <div
                        key={index}
                        className={`dot ${index === currentIndex ? 'active' : ''}`}
                        onClick={() => setCurrentIndex(index)}
                    />
                ))}
            </div>
        </div>
    );
};

export default Section2;